import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const HeaderLogo = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogoClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
      return;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="fixed top-0 left-1/2 -translate-x-1/2 z-[100] flex items-start pointer-events-none">
      {/* Left curve */}
      <div className="-mr-[1px] relative z-10 w-[clamp(36px,10vw,50px)] h-[40px] md:w-[70px] md:h-[52px]">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none" fill="black" xmlns="http://www.w3.org/2000/svg">
          <path d="M 0 0 L 20 0 C 35 0, 45 15, 55 35 L 75 75 C 85 95, 95 100, 100 100 L 100 0 Z"></path>
        </svg>
      </div>

      {/* Center logo - clickable to go home */}
      <div 
        className="bg-black flex flex-col items-center justify-center overflow-hidden pointer-events-auto relative z-20 w-[clamp(120px,34vw,160px)] h-[40px] md:w-[220px] md:h-[52px]"
      >
        <button 
          onClick={handleLogoClick}
          className="relative flex items-center justify-center w-full h-full cursor-pointer"
          data-testid="logo-home-button"
        >
          <motion.div
            className="absolute text-[#c8c7c9] font-inter font-medium tracking-[0.08em] md:tracking-[0.14em] text-[9px] md:text-[13px] uppercase text-center px-1 max-w-full"
            animate={{ 
              opacity: scrolled ? 0 : 1, 
              y: scrolled ? -20 : 0,
              scale: scrolled ? 0.8 : 1
            }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
          >
            ANDREA FAGIOLI
          </motion.div>
          <motion.div
            className="absolute flex items-center justify-center"
            animate={{
              opacity: scrolled ? 1 : 0,
              y: scrolled ? 0 : 20,
              scale: scrolled ? 1 : 0.8,
            }}
            transition={{ duration: 0.4, ease: 'easeInOut' }}
          >
            <img
              src="/logo-af.png"
              alt="Andrea Fagioli"
              className="h-[18px] md:h-[22px] w-auto max-w-full object-contain"
              decoding="async"
            />
          </motion.div>
        </button>
      </div>

      {/* Right curve */}
      <div className="-ml-[1px] relative z-10 w-[clamp(36px,10vw,50px)] h-[40px] md:w-[70px] md:h-[52px]">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none" fill="black" xmlns="http://www.w3.org/2000/svg" style={{ transform: 'scaleX(-1)' }}>
          <path d="M 0 0 L 20 0 C 35 0, 45 15, 55 35 L 75 75 C 85 95, 95 100, 100 100 L 100 0 Z"></path>
        </svg>
      </div>
    </div>
  );
};

export default HeaderLogo;
